import { graphql, Link } from 'gatsby';
import { Layout, Code, Showcase, Header } from "../../../../src/components";
import "../../../../src/pages/wt/patterns/footer/style.scss";
import data from "../../../../src/pages/wt/patterns/footer/data.json";
import changelog from "../../../../src/data/changelog.json";
import * as React from 'react';
export default {
  graphql,
  Link,
  Layout,
  Code,
  Showcase,
  Header,
  data,
  changelog,
  React
};